import { withStateHandlers, compose, lifecycle } from 'recompose'
import {
  either,
  isNil,
  isEmpty,
  head,
  ifElse,
  pipe,
  split,
  last,
  has,
  test,
} from 'ramda'

const getTab = ifElse(test(/.+\/.+/), pipe(split('/'), last), () => undefined)

// getTabName is important because not all instances of using tab from
// tab navigation have been migrated to look for tab.name, some still just use tab,
// expecting that to be the tabName. This is a way to provide an interface for all cases
export const getTabName = (tab = {}, defaultTab = '') => {
  return (has('name', tab) ? tab.name : tab) || defaultTab
}

/**
 *  withTabNavigation:
 *  You could pass in array of tabs, and this enhancer
 *  will return you a handler (`setTabActive`)
 *  that update prop `tabs` when calling the handler.
 *
 *  And, if the incoming props contain path info in `drawerType`,
 *  it will automatically set active tab to the path.
 */
const withTabNavigation = getInitialTabs => {
  const initialTabs =
    typeof getInitialTabs === 'function' ? getInitialTabs() : getInitialTabs
  return compose(
    withStateHandlers(
      props => ({
        tabs: initialTabs,
        selectedTab: either(isNil, isEmpty)(getTab(props.drawerType))
          ? head(initialTabs)
          : { name: getTab(props.drawerType) },
      }),
      {
        setTabActive:
          () =>
          (targetTab = head(initialTabs)) => ({
            selectedTab: targetTab,
          }),
      },
    ),
    lifecycle({
      componentDidUpdate(prevProps) {
        if (this.props.drawerType !== prevProps.drawerType) {
          const activeTab = getTab(this.props.drawerType)
          this.props.setTabActive({ name: activeTab })
        }
      },
    }),
  )
}

export default withTabNavigation
